import { useRef, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export default function HeroSection() {
  const [visible, setVisible] = useState(false);
  useEffect(() => { setTimeout(() => setVisible(true), 100); }, []);

  const scrollToSection = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-cream">
      {/* Background subtle pattern */}
      <div className="absolute inset-0 bg-gradient-to-br from-cream via-cream-dark/40 to-gold-pale/30" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 w-full pt-20 pb-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 md:gap-16 items-center">
          {/* Text Content */}
          <div className={`transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            <span className="inline-block text-xs font-medium tracking-[0.2em] text-gold uppercase mb-5 border border-gold-light px-4 py-1.5 rounded-full">
              Uzman Aile Danışmanı
            </span>
            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light text-warm-dark leading-[1.15] mb-6">
              Hayat bazen<br />
              <em className="italic font-normal text-gold">zorlaşabilir…</em><br />
              ama yalnız<br />
              değilsiniz.
            </h1>
            <p className="text-warm-mid text-base md:text-lg leading-relaxed mb-8 max-w-md">
              Uzm. Aile Danışmanı <strong className="text-warm-dark font-medium">Ayşegül Sert</strong> olarak; aile, çift ve bireysel danışmanlık alanlarında bilimsel, empatik ve güvenli bir alan sunuyorum.
            </p>

            {/* Trust Badges */}
            <div className="flex flex-wrap gap-4 mb-10">
              {['15+ Yıl Deneyim', '2.000+ Seans', 'Lisanslı & Sertifikalı'].map((badge) => (
                <div key={badge} className="flex items-center gap-2 text-xs text-warm-mid">
                  <span className="w-4 h-4 flex items-center justify-center"><i className="ri-checkbox-circle-fill text-gold" /></span>
                  {badge}
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={() => scrollToSection('hizmetler')}
                className="px-7 py-3.5 bg-warm-dark text-cream-dark text-sm font-medium rounded-full hover:bg-gold transition-colors cursor-pointer whitespace-nowrap"
              >
                Size en uygun alanı seçin
              </button>
              <button
                onClick={() => scrollToSection('randevu')}
                className="px-7 py-3.5 border border-warm-mid text-warm-dark text-sm font-medium rounded-full hover:border-gold hover:text-gold transition-colors cursor-pointer whitespace-nowrap"
              >
                Randevu uygunluğunu sorgula
              </button>
            </div>
          </div>

          {/* Image */}
          <div className={`relative transition-all duration-700 delay-200 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            <div className="relative mx-auto w-full max-w-sm lg:max-w-full">
              {/* Decorative frame */}
              <div className="absolute -top-4 -right-4 w-full h-full border-2 border-gold-light rounded-2xl" />
              <div className="relative rounded-2xl overflow-hidden w-full h-[500px] md:h-[580px]">
                <img
                  src="https://storage.readdy-site.link/project_files/48992e90-baf8-4202-b6dc-8d2a52120724/56383216-8373-4bbe-bbd7-0db3e7373608_rek2.png?v=6018137f75ec0ddc9cf02e3c895ee533"
                  alt="Uzm. Aile Danışmanı Ayşegül Sert"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-warm-dark/20 to-transparent" />
              </div>

              {/* Floating card */}
              <div className="absolute -bottom-5 -left-4 bg-white rounded-xl px-5 py-4 shadow-md border border-cream-deeper">
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className="ri-award-fill text-gold text-xl" />
                  </div>
                  <div>
                    <p className="text-xs font-semibold text-warm-dark">Uzm. Ayşegül Sert</p>
                    <p className="text-xs text-warm-light">Lisanslı Aile Danışmanı</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-warm-light">
        <p className="text-xs tracking-widest uppercase">Aşağı kaydır</p>
        <div className="w-px h-10 bg-gradient-to-b from-warm-light to-transparent animate-pulse" />
      </div>
    </section>
  );
}